import { Action, Dispatch } from 'redux'
import { initConfirmAction } from 'reducks/confirm/actions'

const initConfirm = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(initConfirmAction())
  }
}

export default initConfirm
